export enum DeveloperRoutes {
  root = 'developer',
  accessTokens = 'access-tokens',
  applications = 'applications',
  authorizedApps = 'authorized-apps',
}
